/* eslint-disable no-unused-vars */
import type { Option } from '@frontend/libs/types/product'
import type React from 'react'

import { useEffect, useRef, useState } from 'react'

import { ColorSwatch } from './ColorSwatch'
import { DuoColorSwatch } from './DuoColorSwatch'
import { ImageSwatch } from './ImageSwatch'
import Label from './Label'
import { TextSwatch } from './TextSwatch'

export type SelectedOption = { [key: string]: string }

export interface SwatchProps {
  maxDisplay?: number
  onClick: (values: SelectedOption) => void
  option: Option
  value?: string
}

export const Swatch: React.FC<{ showLabel?: boolean } & SwatchProps> = ({
  maxDisplay = 5,
  onClick,
  option,
  showLabel,
  value = '',
}) => {
  const totalSwatches = option.swatches.length
  const displayedSwatches = option.swatches.slice(0, maxDisplay)
  const remainingCount = totalSwatches - displayedSwatches.length

  return (
    <>
      {showLabel && <Label name={option.name} value={value} />}
      <div className="flex flex-wrap items-center gap-1">
        {displayedSwatches.map((item, index) => {
          if (item.type === 'colour-swatch') {
            return (
              <ColorSwatch
                item={item}
                key={index}
                onClick={onClick}
                option={option}
                value={value}
              />
            )
          }

          if (item.type === 'duo-colour-swatch') {
            return (
              <DuoColorSwatch
                item={item}
                key={index}
                onClick={onClick}
                option={option}
                value={value}
              />
            )
          }

          if (item.type === 'image-swatch') {
            return (
              <ImageSwatch
                item={item}
                key={index}
                onClick={onClick}
                option={option}
                value={value}
              />
            )
          }

          if (item.type === 'text-swatch') {
            return (
              <TextSwatch
                item={item}
                key={index}
                onClick={onClick}
                option={option}
                value={value}
              />
            )
          }

          return <></>
        })}
        {remainingCount > 0 && (
          <div className="text-xs text-primary">+{remainingCount}</div>
        )}
      </div>
    </>
  )
}

export default Swatch
